<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Estoque', 'link' : urlReturn },
      ]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Detalhes do Item</span>
      </div>
      <div class="col-6 text-end">
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/stock/new', query: { edit: true, id: dados.id } }">
          <i class="bi bi-pencil-fill me-2"></i>Editar  
        </router-link>
        <button v-show="isAdmin" @click="showModal_delete()" class="btn btn-sm btn-danger me-2"><i class="bi bi-trash3-fill me-2"></i>Deletar</button>
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show"/>

    <div v-if="dados.id != null" class="row">
      <div class="col mx-auto " style="margin-bottom: 40px;" id="conteudoParaImprimir">
        <div class="card">
          <div class="card-body">
            <div class="text-center mb-2">
              <img :src="dados.foto_url" style="height: 200px; object-fit: cover;" class="mb-2" alt="Foto do Item">
            </div>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="1">Item: {{ dados.name }}</td>
                  <td colspan="1">Link: {{ dados.link }}</td>
                </tr>
                <tr>
                  <td colspan="2">Cetegoria: {{ dados.category }}</td>
                </tr>
                <tr>
                  <td>Descrição: {{ dados.description }}</td>
                  <td>Preço: R$ {{ parseFloat(dados.unit_price).toFixed(2) }}</td>
                </tr>
                <tr>
                  <td>Status: {{ dados.status }}</td>
                  <td>Codigo: {{ dados.code }}</td>
                </tr>
                <tr>
                  <td>Quantidade: {{ dados.quant }}</td>
                  <td>Em manutençaõ: 0</td>
                </tr>
                <!-- Fico devendo: Lista de Fornecedores, quantidade de locações no utimos 60 dias, lista de movimentações de estoque -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Modal de Delete -->
    <div class="modal fade" id="modal_delete" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Confirmar Exclusão</h5>
              <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-center">
            <i class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 3rem;"></i>
            <p class="mt-3">Tem certeza que deseja excluir <strong>{{ dados.name }}</strong>?</p>
            <p class="text-muted small">Esta ação não pode ser desfeita e pode afetar o estoque.</p>
          </div>
          <div class="modal-footer">
              <button type="button" @click="closeModal" class="btn btn-secondary">Cancelar</button>
              <button type="button" @click="confirmExcluir" :disabled="deleteLoading" class="btn btn-danger">
                <span v-if="deleteLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Excluir</span>
              </button>
          </div>
        </div>  
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { itens } from '@/models/itens';
import { Modal } from 'bootstrap';
import { onMounted, reactive, ref } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "DetailsView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const urlReturn = '/stock';
    var modal = '';
    var deleteLoading = ref(false);
    const toastStore = useToastStore();
    const { isAdmin, isUser, isOpeto } = usePermissions();
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    const model = itens();

    function goReturn() {
      router.push(urlReturn);
    }

    var dados = reactive({
      id: null,
      name: null,
      description: null,
      link: null,
      status: null,
      category: null,
      foto_url: null,
      code: null,
      unit_price: null,
      quant: null
    });

    function imprimir() {
      window.print();
    }

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      openModal('modal_delete');
    }

    function confirmExcluir() {
      deleteLoading.value = true;
      model.delet(dados.id).then(() => {
        toastStore.success('Item excluído com sucesso.');
        closeModal();
        goReturn();
      }).catch((error) => {
        deleteLoading.value = false;
        toastStore.error('Erro ao excluir item: ' + parseError(error));
      });
    }

    onMounted(() => {
      model.getOne(id).then((response) => {
          dados.id = response.id;
          dados.name = response.name;
          dados.description = response.description;
          dados.link = response.link;
          dados.status = response.status;
          dados.category = response.category.name;
          dados.foto_url = response.foto_url;
          dados.code = response.code;
          dados.unit_price = response.unit_price;
          dados.quant = response.quant;
      });
    });

    return {
      dados,
      imprimir,isAdmin, isUser, isOpeto,
      goReturn, urlReturn,
      showModal_delete,confirmExcluir,closeModal,deleteLoading
    }
  }
}
</script>

<style scoped>

  .header-print {
    display: none;
  }

  @media print {
    /* Esconde tudo no corpo */
    body * {
      visibility: hidden;
    }

    .print-no-show {
      display: none !important;
    }

    .header-print {
      display: block;
      margin-bottom: 20px;
      margin-top: -10px;
    }
    
    /* Mostra apenas a div de impressão */
    #conteudoParaImprimir, #conteudoParaImprimir * {
      visibility: visible;
    }
    
    /* Opcional: Forçar quebra de página */
    #conteudoParaImprimir p {
      page-break-inside: avoid;
    }
  }

</style>